import { createContext } from 'react';
export const View360Context = createContext({
    imagesLoaderCounter: 0,
    setImagesLoaderCounter: () => ({}),
});
